import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import './media/quickInput.css';
import { NO_KEY_MODS, ItemActivation } from '../common/quickInput.js';
import * as dom from '../../../browser/dom.js';
import { CancellationToken } from '../../../common/cancellation.js';
import { QuickInputList, QuickInputListFocus } from './quickInputList.js';
import { QuickInputBox } from './quickInputBox.js';
import { StandardKeyboardEvent } from '../../../browser/keyboardEvent.js';
import { localize } from '../../../../nls.js';
import { CountBadge } from '../../../browser/ui/countBadge/countBadge.js';
import { ProgressBar } from '../../../browser/ui/progressbar/progressbar.js';
import { Emitter } from '../../../common/event.js';
import { Button } from '../../../browser/ui/button/button.js';
import { dispose, Disposable, DisposableStore } from '../../../common/lifecycle.js';
import Severity from '../../../common/severity.js';
import { ActionBar } from '../../../browser/ui/actionbar/actionbar.js';
import { Action } from '../../../common/actions.js';
import { equals } from '../../../common/arrays.js';
import { TimeoutTimer } from '../../../common/async.js';
import { getIconClass } from './quickInputUtils.js';
import { registerIcon, Codicon } from '../../../common/codicons.js';
var $ = dom.$;
var backButtonIcon = registerIcon('quick-input-back', Codicon.arrowLeft);
var backButton = {
  iconClass: backButtonIcon.classNames,
  tooltip: localize('quickInput.back', "Back"),
  handle: -1 // TODO

};

var QuickInput = /*#__PURE__*/function (_Disposable) {
  _inherits(QuickInput, _Disposable);

  var _super = _createSuper(QuickInput);

  function QuickInput(ui) {
    var _this;

    _classCallCheck(this, QuickInput);

    _this = _super.call(this);
    _this.ui = ui;
    _this.visible = false;
    _this._enabled = true;
    _this._busy = false;
    _this._ignoreFocusOut = false;
    _this._buttons = [];
    _this.buttonsUpdated = false;
    _this.onDidTriggerButtonEmitter = _this._register(new Emitter());
    _this.onDidHideEmitter = _this._register(new Emitter());
    _this.onDisposeEmitter = _this._register(new Emitter());
    _this.visibleDisposables = _this._register(new DisposableStore());
    _this.onDidHide = _this.onDidHideEmitter.event;
    return _this;
  }

  _createClass(QuickInput, [{
    key: "title",
    get: function get() {
      return this._title;
    },
    set: function set(title) {
      this._title = title;
      this.update();
    }
  }, {
    key: "description",
    get: function get() {
      return this._description;
    },
    set: function set(description) {
      this._description = description;
      this.update();
    }
  }, {
    key: "step",
    get: function get() {
      return this._steps;
    },
    set: function set(step) {
      this._steps = step;
      this.update();
    }
  }, {
    key: "totalSteps",
    get: function get() {
      return this._totalSteps;
    },
    set: function set(totalSteps) {
      this._totalSteps = totalSteps;
      this.update();
    }
  }, {
    key: "enabled",
    get: function get() {
      return this._enabled;
    },
    set: function set(enabled) {
      this._enabled = enabled;
      this.update();
    }
  }, {
    key: "contextKey",
    get: function get() {
      return this._contextKey;
    },
    set: function set(contextKey) {
      this._contextKey = contextKey;
      this.update();
    }
  }, {
    key: "busy",
    get: function get() {
      return this._busy;
    },
    set: function set(busy) {
      this._busy = busy;
      this.update();
    }
  }, {
    key: "ignoreFocusOut",
    get: function get() {
      return this._ignoreFocusOut;
    },
    set: function set(ignoreFocusOut) {
      this._ignoreFocusOut = ignoreFocusOut;
      this.update();
    }
  }, {
    key: "buttons",
    get: function get() {
      return this._buttons;
    },
    set: function set(buttons) {
      this._buttons = buttons;
      this.buttonsUpdated = true;
      this.update();
    }
  }, {
    key: "show",
    value: function show() {
      var _this2 = this;

      if (this.visible) {
        return;
      }

      this.visibleDisposables.add(this.ui.onDidTriggerButton(function (button) {
        if (_this2.buttons.indexOf(button) !== -1) {
          _this2.onDidTriggerButtonEmitter.fire(button);
        }
      }));
      this.ui.show(this);
      this.visible = true;
      this.update();
    }
  }, {
    key: "hide",
    value: function hide() {
      if (!this.visible) {
        return;
      }

      this.ui.hide();
    }
  }, {
    key: "didHide",
    value: function didHide() {
      this.visible = false;
      this.visibleDisposables.clear();
      this.onDidHideEmitter.fire();
    }
  }, {
    key: "update",
    value: function update() {
      var _this3 = this;

      if (!this.visible) {
        return;
      }

      var title = this.getTitle();

      if (title && this.ui.title.textContent !== title) {
        this.ui.title.textContent = title;
      } else if (!title && this.ui.title.innerHTML !== '&nbsp;') {
        this.ui.title.innerText = "\xA0;";
      }

      var description = this.getDescription();

      if (this.ui.description.textContent !== description) {
        this.ui.description.textContent = description;
      }

      if (this.busy && !this.busyDelay) {
        this.busyDelay = new TimeoutTimer();
        this.busyDelay.setIfNotSet(function () {
          if (_this3.visible) {
            _this3.ui.progressBar.infinite();
          }
        }, 800);
      }

      if (!this.busy && this.busyDelay) {
        this.ui.progressBar.stop();
        this.busyDelay.cancel();
        this.busyDelay = undefined;
      }

      if (this.buttonsUpdated) {
        this.buttonsUpdated = false;
        this.ui.leftActionBar.clear();
        var leftButtons = this.buttons.filter(function (button) {
          return button === backButton;
        });
        this.ui.leftActionBar.push(leftButtons.map(function (button, index) {
          var action = new Action("id-".concat(index), '', button.iconClass || getIconClass(button.iconPath), true, function () {
            return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      this.onDidTriggerButtonEmitter.fire(button);

                    case 1:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, this);
            }));
          });
          action.tooltip = button.tooltip || '';
          return action;
        }), {
          icon: true,
          label: false
        });
        this.ui.rightActionBar.clear();
        var rightButtons = this.buttons.filter(function (button) {
          return button !== backButton;
        });
        this.ui.rightActionBar.push(rightButtons.map(function (button, index) {
          var action = new Action("id-".concat(index), '', button.iconClass || getIconClass(button.iconPath), true, function () {
            return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      this.onDidTriggerButtonEmitter.fire(button);

                    case 1:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2, this);
            }));
          });
          action.tooltip = button.tooltip || '';
          return action;
        }), {
          icon: true,
          label: false
        });
      }

      this.ui.ignoreFocusOut = this.ignoreFocusOut;
      this.ui.setEnabled(this.enabled);
      this.ui.setContextKey(this.contextKey);
    }
  }, {
    key: "getTitle",
    value: function getTitle() {
      if (this.title && this.step) {
        return "".concat(this.title, " (").concat(this.getSteps(), ")");
      }

      if (this.title) {
        return this.title;
      }

      if (this.step) {
        return this.getSteps();
      }

      return '';
    }
  }, {
    key: "getDescription",
    value: function getDescription() {
      return this.description || '';
    }
  }, {
    key: "getSteps",
    value: function getSteps() {
      if (this.step && this.totalSteps) {
        return localize('quickInput.steps', "{0}/{1}", this.step, this.totalSteps);
      }

      if (this.step) {
        return String(this.step);
      }

      return '';
    }
  }, {
    key: "showMessageDecoration",
    value: function showMessageDecoration(severity) {
      this.ui.inputBox.showDecoration(severity);

      if (severity === Severity.Error) {
        var styles = this.ui.inputBox.stylesForType(severity);
        this.ui.message.style.color = styles.foreground ? "".concat(styles.foreground) : '';
        this.ui.message.style.backgroundColor = styles.background ? "".concat(styles.background) : '';
        this.ui.message.style.border = styles.border ? "1px solid ".concat(styles.border) : '';
        this.ui.message.style.paddingBottom = '4px';
      } else {
        this.ui.message.style.color = '';
        this.ui.message.style.backgroundColor = '';
        this.ui.message.style.border = '';
        this.ui.message.style.paddingBottom = '';
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.hide();
      this.onDisposeEmitter.fire();

      _get(_getPrototypeOf(QuickInput.prototype), "dispose", this).call(this);
    }
  }]);

  return QuickInput;
}(Disposable);

var QuickPick = /*#__PURE__*/function (_QuickInput) {
  _inherits(QuickPick, _QuickInput);

  var _super2 = _createSuper(QuickPick);

  function QuickPick() {
    var _this4;

    _classCallCheck(this, QuickPick);

    _this4 = _super2.apply(this, arguments);
    _this4._value = '';
    _this4.onDidChangeValueEmitter = _this4._register(new Emitter());
    _this4.onDidAcceptEmitter = _this4._register(new Emitter());
    _this4.onDidCustomEmitter = _this4._register(new Emitter());
    _this4._items = [];
    _this4.itemsUpdated = false;
    _this4._canSelectMany = false;
    _this4._canAcceptInBackground = false;
    _this4._matchOnDescription = false;
    _this4._matchOnDetail = false;
    _this4._matchOnLabel = true;
    _this4._sortByLabel = true;
    _this4._autoFocusOnList = true;
    _this4._itemActivation = _this4.ui.isScreenReaderOptimized() ? ItemActivation.NONE
    /* https://github.com/microsoft/vscode/issues/57501 */
    : ItemActivation.FIRST;
    _this4._activeItems = [];
    _this4.activeItemsUpdated = false;
    _this4.activeItemsToConfirm = [];
    _this4.onDidChangeActiveEmitter = _this4._register(new Emitter());
    _this4._selectedItems = [];
    _this4.selectedItemsUpdated = false;
    _this4.selectedItemsToConfirm = [];
    _this4.onDidChangeSelectionEmitter = _this4._register(new Emitter());
    _this4.onDidTriggerItemButtonEmitter = _this4._register(new Emitter());
    _this4.valueSelectionUpdated = true;
    _this4._ok = 'default';
    _this4._customButton = false;

    _this4.filterValue = function (value) {
      return value;
    };

    _this4.onDidChangeValue = _this4.onDidChangeValueEmitter.event;
    _this4.onDidAccept = _this4.onDidAcceptEmitter.event;
    _this4.onDidChangeActive = _this4.onDidChangeActiveEmitter.event;
    _this4.onDidChangeSelection = _this4.onDidChangeSelectionEmitter.event;
    _this4.onDidTriggerItemButton = _this4.onDidTriggerItemButtonEmitter.event;
    return _this4;
  }

  _createClass(QuickPick, [{
    key: "quickNavigate",
    get: function get() {
      return this._quickNavigate;
    },
    set: function set(quickNavigate) {
      this._quickNavigate = quickNavigate;
      this.update();
    }
  }, {
    key: "value",
    get: function get() {
      return this._value;
    },
    set: function set(value) {
      this._value = value || '';
      this.update();
    }
  }, {
    key: "ariaLabel",
    get: function get() {
      return this._ariaLabel;
    },
    set: function set(ariaLabel) {
      this._ariaLabel = ariaLabel;
      this.update();
    }
  }, {
    key: "placeholder",
    get: function get() {
      return this._placeholder;
    },
    set: function set(placeholder) {
      this._placeholder = placeholder;
      this.update();
    }
  }, {
    key: "items",
    get: function get() {
      return this._items;
    },
    set: function set(items) {
      this._items = items;
      this.itemsUpdated = true;
      this.update();
    }
  }, {
    key: "canSelectMany",
    get: function get() {
      return this._canSelectMany;
    },
    set: function set(canSelectMany) {
      this._canSelectMany = canSelectMany;
      this.update();
    }
  }, {
    key: "canAcceptInBackground",
    get: function get() {
      return this._canAcceptInBackground;
    },
    set: function set(canAcceptInBackground) {
      this._canAcceptInBackground = canAcceptInBackground;
    }
  }, {
    key: "matchOnDescription",
    get: function get() {
      return this._matchOnDescription;
    },
    set: function set(matchOnDescription) {
      this._matchOnDescription = matchOnDescription;
      this.update();
    }
  }, {
    key: "matchOnDetail",
    get: function get() {
      return this._matchOnDetail;
    },
    set: function set(matchOnDetail) {
      this._matchOnDetail = matchOnDetail;
      this.update();
    }
  }, {
    key: "matchOnLabel",
    get: function get() {
      return this._matchOnLabel;
    },
    set: function set(matchOnLabel) {
      this._matchOnLabel = matchOnLabel;
      this.update();
    }
  }, {
    key: "sortByLabel",
    get: function get() {
      return this._sortByLabel;
    },
    set: function set(sortByLabel) {
      this._sortByLabel = sortByLabel;
      this.update();
    }
  }, {
    key: "autoFocusOnList",
    get: function get() {
      return this._autoFocusOnList;
    },
    set: function set(autoFocusOnList) {
      this._autoFocusOnList = autoFocusOnList;
      this.update();
    }
  }, {
    key: "itemActivation",
    get: function get() {
      return this._itemActivation;
    },
    set: function set(itemActivation) {
      this._itemActivation = itemActivation;
    }
  }, {
    key: "activeItems",
    get: function get() {
      return this._activeItems;
    },
    set: function set(activeItems) {
      this._activeItems = activeItems;
      this.activeItemsUpdated = true;
      this.update();
    }
  }, {
    key: "selectedItems",
    get: function get() {
      return this._selectedItems;
    },
    set: function set(selectedItems) {
      this._selectedItems = selectedItems;
      this.selectedItemsUpdated = true;
      this.update();
    }
  }, {
    key: "keyMods",
    get: function get() {
      if (this._quickNavigate) {
        // Disable keyMods when quick navigate is enabled
        // because in this model the interaction is purely
        // keyboard driven and Ctrl/Alt are typically
        // pressed and hold during this interaction.
        return NO_KEY_MODS;
      }

      return this.ui.keyMods;
    }
  }, {
    key: "valueSelection",
    set: function set(valueSelection) {
      this._valueSelection = valueSelection;
      this.valueSelectionUpdated = true;
      this.update();
    }
  }, {
    key: "validationMessage",
    get: function get() {
      return this._validationMessage;
    },
    set: function set(validationMessage) {
      this._validationMessage = validationMessage;
      this.update();
    }
  }, {
    key: "customButton",
    get: function get() {
      return this._customButton;
    },
    set: function set(showCustomButton) {
      this._customButton = showCustomButton;
      this.update();
    }
  }, {
    key: "customLabel",
    get: function get() {
      return this._customButtonLabel;
    },
    set: function set(label) {
      this._customButtonLabel = label;
      this.update();
    }
  }, {
    key: "customHover",
    get: function get() {
      return this._customButtonHover;
    },
    set: function set(hover) {
      this._customButtonHover = hover;
      this.update();
    }
  }, {
    key: "ok",
    get: function get() {
      return this._ok;
    },
    set: function set(showOkButton) {
      this._ok = showOkButton;
      this.update();
    }
  }, {
    key: "hideInput",
    get: function get() {
      return !!this._hideInput;
    },
    set: function set(hideInput) {
      this._hideInput = hideInput;
      this.update();
    }
  }, {
    key: "trySelectFirst",
    value: function trySelectFirst() {
      if (this.autoFocusOnList) {
        if (!this.canSelectMany) {
          this.ui.list.focus(QuickInputListFocus.First);
        }
      }
    }
  }, {
    key: "show",
    value: function show() {
      var _this5 = this;

      if (!this.visible) {
        this.visibleDisposables.add(this.ui.inputBox.onDidChange(function (value) {
          if (value === _this5.value) {
            return;
          }

          _this5._value = value;

          var didFilter = _this5.ui.list.filter(_this5.filterValue(_this5.ui.inputBox.value));

          if (didFilter) {
            _this5.trySelectFirst();
          }

          _this5.onDidChangeValueEmitter.fire(value);
        }));
        this.visibleDisposables.add(this.ui.inputBox.onMouseDown(function (event) {
          if (!_this5.autoFocusOnList) {
            _this5.ui.list.clearFocus();
          }
        }));
        this.visibleDisposables.add((this._hideInput ? this.ui.list : this.ui.inputBox).onKeyDown(function (event) {
          switch (event.keyCode) {
            case 18
            /* DownArrow */
            :
              _this5.ui.list.focus(QuickInputListFocus.Next);

              if (_this5.canSelectMany) {
                _this5.ui.list.domFocus();
              }

              dom.EventHelper.stop(event, true);
              break;

            case 16
            /* UpArrow */
            :
              if (_this5.ui.list.getFocusedElements().length) {
                _this5.ui.list.focus(QuickInputListFocus.Previous);
              } else {
                _this5.ui.list.focus(QuickInputListFocus.Last);
              }

              if (_this5.canSelectMany) {
                _this5.ui.list.domFocus();
              }

              dom.EventHelper.stop(event, true);
              break;

            case 12
            /* PageDown */
            :
              _this5.ui.list.focus(QuickInputListFocus.NextPage);

              if (_this5.canSelectMany) {
                _this5.ui.list.domFocus();
              }

              dom.EventHelper.stop(event, true);
              break;

            case 11
            /* PageUp */
            :
              _this5.ui.list.focus(QuickInputListFocus.PreviousPage);

              if (_this5.canSelectMany) {
                _this5.ui.list.domFocus();
              }

              dom.EventHelper.stop(event, true);
              break;

            case 17
            /* RightArrow */
            :
              if (!_this5._canAcceptInBackground) {
                return; // needs to be enabled
              }

              if (!_this5.ui.inputBox.isSelectionAtEnd()) {
                return; // ensure input box selection at end
              }

              if (_this5.activeItems[0]) {
                _this5._selectedItems = [_this5.activeItems[0]];

                _this5.onDidChangeSelectionEmitter.fire(_this5.selectedItems);

                _this5.onDidAcceptEmitter.fire({
                  inBackground: true
                });
              }

              break;

            case 14
            /* Home */
            :
              if ((event.ctrlKey || event.metaKey) && !event.shiftKey && !event.altKey) {
                _this5.ui.list.focus(QuickInputListFocus.First);

                dom.EventHelper.stop(event, true);
              }

              break;

            case 13
            /* End */
            :
              if ((event.ctrlKey || event.metaKey) && !event.shiftKey && !event.altKey) {
                _this5.ui.list.focus(QuickInputListFocus.Last);

                dom.EventHelper.stop(event, true);
              }

              break;
          }
        }));
        this.visibleDisposables.add(this.ui.onDidAccept(function () {
          if (!_this5.canSelectMany && _this5.activeItems[0]) {
            _this5._selectedItems = [_this5.activeItems[0]];

            _this5.onDidChangeSelectionEmitter.fire(_this5.selectedItems);
          }

          _this5.onDidAcceptEmitter.fire({
            inBackground: false
          });
        }));
        this.visibleDisposables.add(this.ui.onDidCustom(function () {
          _this5.onDidCustomEmitter.fire();
        }));
        this.visibleDisposables.add(this.ui.list.onDidChangeFocus(function (focusedItems) {
          if (_this5.activeItemsUpdated) {
            return; // Expect another event.
          }

          if (_this5.activeItemsToConfirm !== _this5._activeItems && equals(focusedItems, _this5._activeItems, function (a, b) {
            return a === b;
          })) {
            return;
          }

          _this5._activeItems = focusedItems;

          _this5.onDidChangeActiveEmitter.fire(focusedItems);
        }));
        this.visibleDisposables.add(this.ui.list.onDidChangeSelection(function (_ref) {
          var selectedItems = _ref.items,
              event = _ref.event;

          if (_this5.canSelectMany) {
            if (selectedItems.length) {
              _this5.ui.list.setSelectedElements([]);
            }

            return;
          }

          if (_this5.selectedItemsToConfirm !== _this5._selectedItems && equals(selectedItems, _this5._selectedItems, function (a, b) {
            return a === b;
          })) {
            return;
          }

          _this5._selectedItems = selectedItems;

          _this5.onDidChangeSelectionEmitter.fire(selectedItems);

          if (selectedItems.length) {
            _this5.onDidAcceptEmitter.fire({
              inBackground: event instanceof MouseEvent && event.button === 1
              /* mouse middle click */

            });
          }
        }));
        this.visibleDisposables.add(this.ui.list.onChangedCheckedElements(function (checkedItems) {
          if (!_this5.canSelectMany) {
            return;
          }

          if (_this5.selectedItemsToConfirm !== _this5._selectedItems && equals(checkedItems, _this5._selectedItems, function (a, b) {
            return a === b;
          })) {
            return;
          }

          _this5._selectedItems = checkedItems;

          _this5.onDidChangeSelectionEmitter.fire(checkedItems);
        }));
        this.visibleDisposables.add(this.ui.list.onButtonTriggered(function (event) {
          return _this5.onDidTriggerItemButtonEmitter.fire(event);
        }));
        this.visibleDisposables.add(this.registerQuickNavigation());
        this.valueSelectionUpdated = true;
      }

      _get(_getPrototypeOf(QuickPick.prototype), "show", this).call(this); // TODO: Why have show() bubble up while update() trickles down? (Could move setComboboxAccessibility() here.)

    }
  }, {
    key: "registerQuickNavigation",
    value: function registerQuickNavigation() {
      var _this6 = this;

      return dom.addDisposableListener(this.ui.container, dom.EventType.KEY_UP, function (e) {
        if (_this6.canSelectMany || !_this6._quickNavigate) {
          return;
        }

        var keyboardEvent = new StandardKeyboardEvent(e);
        var keyCode = keyboardEvent.keyCode; // Select element when keys are pressed that signal it

        var quickNavKeys = _this6._quickNavigate.keybindings;
        var wasTriggerKeyPressed = quickNavKeys.some(function (k) {
          var _k$getParts = k.getParts(),
              _k$getParts2 = _slicedToArray(_k$getParts, 2),
              firstPart = _k$getParts2[0],
              chordPart = _k$getParts2[1];

          if (chordPart) {
            return false;
          }

          if (firstPart.shiftKey && keyCode === 4
          /* Shift */
          ) {
            if (keyboardEvent.ctrlKey || keyboardEvent.altKey || keyboardEvent.metaKey) {
              return false; // this is an optimistic check for the shift key being used to navigate back in quick input
            }

            return true;
          }

          if (firstPart.altKey && keyCode === 6
          /* Alt */
          ) {
            return true;
          }

          if (firstPart.ctrlKey && keyCode === 5
          /* Ctrl */
          ) {
            return true;
          }

          if (firstPart.metaKey && keyCode === 57
          /* Meta */
          ) {
            return true;
          }

          return false;
        });

        if (wasTriggerKeyPressed) {
          if (_this6.activeItems[0]) {
            _this6._selectedItems = [_this6.activeItems[0]];

            _this6.onDidChangeSelectionEmitter.fire(_this6.selectedItems);

            _this6.onDidAcceptEmitter.fire({
              inBackground: false
            });
          } // Unset quick navigate after press. It is only valid once
          // and should not result in any behaviour change afterwards
          // if the picker remains open because there was no active item


          _this6._quickNavigate = undefined;
        }
      });
    }
  }, {
    key: "update",
    value: function update() {
      if (!this.visible) {
        return;
      }

      var hideInput = false;
      var inputShownJustForScreenReader = false;

      if (!!this._hideInput && this._items.length > 0) {
        if (this.ui.isScreenReaderOptimized()) {
          // Always show input if screen reader attached https://github.com/microsoft/vscode/issues/94360
          inputShownJustForScreenReader = true;
        } else {
          hideInput = true;
        }
      }

      dom.toggleClass(this.ui.container, 'hidden-input', hideInput);
      var visibilities = {
        title: !!this.title || !!this.step || !!this.buttons.length,
        description: !!this.description,
        checkAll: this.canSelectMany,
        inputBox: !hideInput,
        progressBar: !hideInput,
        visibleCount: true,
        count: this.canSelectMany,
        ok: this.ok === 'default' ? this.canSelectMany : this.ok,
        list: true,
        message: !!this.validationMessage,
        customButton: this.customButton
      };
      this.ui.setVisibilities(visibilities);

      _get(_getPrototypeOf(QuickPick.prototype), "update", this).call(this);

      if (this.ui.inputBox.value !== this.value) {
        this.ui.inputBox.value = this.value;
      }

      if (this.valueSelectionUpdated) {
        this.valueSelectionUpdated = false;
        this.ui.inputBox.select(this._valueSelection && {
          start: this._valueSelection[0],
          end: this._valueSelection[1]
        });
      }

      if (this.ui.inputBox.placeholder !== (this.placeholder || '')) {
        this.ui.inputBox.placeholder = this.placeholder || '';
      }

      if (inputShownJustForScreenReader) {
        this.ui.inputBox.ariaLabel = '';
      } else {
        var ariaLabel = this.ariaLabel || this.placeholder || QuickPick.DEFAULT_ARIA_LABEL;

        if (this.ui.inputBox.ariaLabel !== ariaLabel) {
          this.ui.inputBox.ariaLabel = ariaLabel;
        }
      }

      this.ui.list.matchOnDescription = this.matchOnDescription;
      this.ui.list.matchOnDetail = this.matchOnDetail;
      this.ui.list.matchOnLabel = this.matchOnLabel;
      this.ui.list.sortByLabel = this.sortByLabel;

      if (this.itemsUpdated) {
        this.itemsUpdated = false;
        this.ui.list.setElements(this.items);
        this.ui.list.filter(this.filterValue(this.ui.inputBox.value));
        this.ui.checkAll.checked = this.ui.list.getAllVisibleChecked();
        this.ui.visibleCount.setCount(this.ui.list.getVisibleCount());
        this.ui.count.setCount(this.ui.list.getCheckedCount());

        switch (this._itemActivation) {
          case ItemActivation.NONE:
            this._itemActivation = ItemActivation.FIRST; // only valid once, then unset

            break;

          case ItemActivation.SECOND:
            this.ui.list.focus(QuickInputListFocus.Second);
            this._itemActivation = ItemActivation.FIRST; // only valid once, then unset

            break;

          case ItemActivation.LAST:
            this.ui.list.focus(QuickInputListFocus.Last);
            this._itemActivation = ItemActivation.FIRST; // only valid once, then unset

            break;

          default:
            this.trySelectFirst();
            break;
        }
      }

      if (this.ui.container.classList.contains('show-checkboxes') !== !!this.canSelectMany) {
        if (this.canSelectMany) {
          this.ui.list.clearFocus();
        } else {
          this.trySelectFirst();
        }
      }

      if (this.activeItemsUpdated) {
        this.activeItemsUpdated = false;
        this.activeItemsToConfirm = this._activeItems;
        this.ui.list.setFocusedElements(this.activeItems);

        if (this.activeItemsToConfirm === this._activeItems) {
          this.activeItemsToConfirm = null;
        }
      }

      if (this.selectedItemsUpdated) {
        this.selectedItemsUpdated = false;
        this.selectedItemsToConfirm = this._selectedItems;

        if (this.canSelectMany) {
          this.ui.list.setCheckedElements(this.selectedItems);
        } else {
          this.ui.list.setSelectedElements(this.selectedItems);
        }

        if (this.selectedItemsToConfirm === this._selectedItems) {
          this.selectedItemsToConfirm = null;
        }
      }

      if (this.validationMessage) {
        this.ui.message.textContent = this.validationMessage;
        this.showMessageDecoration(Severity.Error);
      } else {
        this.ui.message.textContent = null;
        this.showMessageDecoration(Severity.Ignore);
      }

      this.ui.customButton.label = this.customLabel || '';
      this.ui.customButton.element.title = this.customHover || '';
      this.ui.setComboboxAccessibility(true);

      if (!visibilities.inputBox) {
        // we need to move focus into the tree to detect keybindings
        // properly when the input box is not visible (quick nav)
        this.ui.list.domFocus();
      }
    }
  }]);

  return QuickPick;
}(QuickInput);

QuickPick.DEFAULT_ARIA_LABEL = localize('quickInputBox.ariaLabel', "Type to narrow down results.");
export var QuickInputController = /*#__PURE__*/function (_Disposable2) {
  _inherits(QuickInputController, _Disposable2);

  var _super3 = _createSuper(QuickInputController);

  function QuickInputController(options) {
    var _this7;

    _classCallCheck(this, QuickInputController);

    _this7 = _super3.call(this);
    _this7.options = options;
    _this7.comboboxAccessibility = false;
    _this7.enabled = true;
    _this7.onDidAcceptEmitter = _this7._register(new Emitter());
    _this7.onDidCustomEmitter = _this7._register(new Emitter());
    _this7.onDidTriggerButtonEmitter = _this7._register(new Emitter());
    _this7.keyMods = {
      ctrlCmd: false,
      alt: false
    };
    _this7.controller = null;
    _this7.onShowEmitter = _this7._register(new Emitter());
    _this7.onShow = _this7.onShowEmitter.event;
    _this7.onHideEmitter = _this7._register(new Emitter());
    _this7.onHide = _this7.onHideEmitter.event;
    _this7.idPrefix = options.idPrefix;
    _this7.parentElement = options.container;
    _this7.styles = options.styles;

    _this7.registerKeyModsListeners();

    return _this7;
  }

  _createClass(QuickInputController, [{
    key: "registerKeyModsListeners",
    value: function registerKeyModsListeners() {
      var _this8 = this;

      var listener = function listener(e) {
        _this8.keyMods.ctrlCmd = e.ctrlKey || e.metaKey;
        _this8.keyMods.alt = e.altKey;
      };

      this._register(dom.addDisposableListener(window, dom.EventType.KEY_DOWN, listener, true));

      this._register(dom.addDisposableListener(window, dom.EventType.KEY_UP, listener, true));

      this._register(dom.addDisposableListener(window, dom.EventType.MOUSE_DOWN, listener, true));
    }
  }, {
    key: "getUI",
    value: function getUI() {
      var _this9 = this;

      if (this.ui) {
        return this.ui;
      }

      var container = dom.append(this.parentElement, $('.quick-input-widget.show-file-icons'));
      container.tabIndex = -1;
      container.style.display = 'none';
      var styleSheet = dom.createStyleSheet(container);
      var titleBar = dom.append(container, $('.quick-input-titlebar'));

      var leftActionBar = this._register(new ActionBar(titleBar));

      leftActionBar.domNode.classList.add('quick-input-left-action-bar');
      var title = dom.append(titleBar, $('.quick-input-title'));

      var rightActionBar = this._register(new ActionBar(titleBar));

      rightActionBar.domNode.classList.add('quick-input-right-action-bar');
      var description = dom.append(container, $('.quick-input-description'));
      var headerContainer = dom.append(container, $('.quick-input-header'));
      var checkAll = dom.append(headerContainer, $('input.quick-input-check-all'));
      checkAll.type = 'checkbox';

      this._register(dom.addStandardDisposableListener(checkAll, dom.EventType.CHANGE, function (e) {
        var checked = checkAll.checked;
        list.setAllVisibleChecked(checked);
      }));

      this._register(dom.addDisposableListener(checkAll, dom.EventType.CLICK, function (e) {
        if (e.x || e.y) {
          // Avoid 'click' triggered by 'space'...
          inputBox.setFocus();
        }
      }));

      var extraContainer = dom.append(headerContainer, $('.quick-input-and-message'));
      var filterContainer = dom.append(extraContainer, $('.quick-input-filter'));

      var inputBox = this._register(new QuickInputBox(filterContainer));

      inputBox.setAttribute('aria-describedby', "".concat(this.idPrefix, "message"));
      var visibleCountContainer = dom.append(filterContainer, $('.quick-input-visible-count'));
      visibleCountContainer.setAttribute('aria-live', 'polite');
      visibleCountContainer.setAttribute('aria-atomic', 'true');
      var visibleCount = new CountBadge(visibleCountContainer, {
        countFormat: localize({
          key: 'quickInput.visibleCount',
          comment: ['This tells the user how many items are shown in a list of items to select from. The items can be anything. Currently not visible, but read by screen readers.']
        }, "{0} Results")
      });
      var countContainer = dom.append(filterContainer, $('.quick-input-count'));
      countContainer.setAttribute('aria-live', 'polite');
      var count = new CountBadge(countContainer, {
        countFormat: localize({
          key: 'quickInput.countSelected',
          comment: ['This tells the user how many items are selected in a list of items to select from. The items can be anything.']
        }, "{0} Selected")
      });
      var okContainer = dom.append(headerContainer, $('.quick-input-action'));
      var ok = new Button(okContainer);
      ok.label = localize('ok', "OK");

      this._register(ok.onDidClick(function (e) {
        _this9.onDidAcceptEmitter.fire();
      }));

      var customButtonContainer = dom.append(headerContainer, $('.quick-input-action'));
      var customButton = new Button(customButtonContainer);
      customButton.label = localize('custom', "Custom");

      this._register(customButton.onDidClick(function (e) {
        _this9.onDidCustomEmitter.fire();
      }));

      var message = dom.append(extraContainer, $("#".concat(this.idPrefix, "message.quick-input-message")));
      var progressBar = new ProgressBar(container);
      dom.addClass(progressBar.getContainer(), 'quick-input-progress');

      var list = this._register(new QuickInputList(container, this.idPrefix + 'list', this.options));

      this._register(list.onChangedAllVisibleChecked(function (checked) {
        checkAll.checked = checked;
      }));

      this._register(list.onChangedVisibleCount(function (c) {
        visibleCount.setCount(c);
      }));

      this._register(list.onChangedCheckedCount(function (c) {
        count.setCount(c);
      }));

      this._register(list.onLeave(function () {
        // Defer to avoid the input field reacting to the triggering key.
        setTimeout(function () {
          inputBox.setFocus();

          if (_this9.controller instanceof QuickPick && _this9.controller.canSelectMany) {
            list.clearFocus();
          }
        }, 0);
      }));

      this._register(list.onDidChangeFocus(function () {
        if (_this9.comboboxAccessibility) {
          _this9.getUI().inputBox.setAttribute('aria-activedescendant', _this9.getUI().list.getActiveDescendant() || '');
        }
      }));

      var focusTracker = dom.trackFocus(container);

      this._register(focusTracker);

      this._register(dom.addDisposableListener(container, dom.EventType.FOCUS, function (e) {
        _this9.previousFocusElement = e.relatedTarget instanceof HTMLElement ? e.relatedTarget : undefined;
      }, true));

      this._register(focusTracker.onDidBlur(function () {
        if (!_this9.getUI().ignoreFocusOut && !_this9.options.ignoreFocusOut()) {
          _this9.hide();
        }

        _this9.previousFocusElement = undefined;
      }));

      this._register(dom.addDisposableListener(container, dom.EventType.FOCUS, function (e) {
        inputBox.setFocus();
      }));

      this._register(dom.addDisposableListener(container, dom.EventType.KEY_DOWN, function (e) {
        var event = new StandardKeyboardEvent(e);

        switch (event.keyCode) {
          case 3
          /* Enter */
          :
            dom.EventHelper.stop(e, true);

            _this9.onDidAcceptEmitter.fire();

            break;

          case 9
          /* Escape */
          :
            dom.EventHelper.stop(e, true);

            _this9.hide();

            break;

          case 2
          /* Tab */
          :
            if (!event.altKey && !event.ctrlKey && !event.metaKey) {
              var selectors = ['.action-label.codicon'];

              if (container.classList.contains('show-checkboxes')) {
                selectors.push('input');
              } else {
                selectors.push('input[type=text]');
              }

              if (_this9.getUI().list.isDisplayed()) {
                selectors.push('.monaco-list');
              }

              var stops = container.querySelectorAll(selectors.join(', '));

              if (event.shiftKey && event.target === stops[0]) {
                dom.EventHelper.stop(e, true);
                stops[stops.length - 1].focus();
              } else if (!event.shiftKey && event.target === stops[stops.length - 1]) {
                dom.EventHelper.stop(e, true);
                stops[0].focus();
              }
            }

            break;
        }
      }));

      this.ui = {
        container: container,
        styleSheet: styleSheet,
        leftActionBar: leftActionBar,
        titleBar: titleBar,
        title: title,
        description: description,
        rightActionBar: rightActionBar,
        checkAll: checkAll,
        filterContainer: filterContainer,
        inputBox: inputBox,
        visibleCountContainer: visibleCountContainer,
        visibleCount: visibleCount,
        countContainer: countContainer,
        count: count,
        okContainer: okContainer,
        ok: ok,
        message: message,
        customButtonContainer: customButtonContainer,
        customButton: customButton,
        progressBar: progressBar,
        list: list,
        onDidAccept: this.onDidAcceptEmitter.event,
        onDidCustom: this.onDidCustomEmitter.event,
        onDidTriggerButton: this.onDidTriggerButtonEmitter.event,
        ignoreFocusOut: false,
        keyMods: this.keyMods,
        isScreenReaderOptimized: function isScreenReaderOptimized() {
          return _this9.options.isScreenReaderOptimized();
        },
        show: function show(controller) {
          return _this9.show(controller);
        },
        hide: function hide() {
          return _this9.hide();
        },
        setVisibilities: function setVisibilities(visibilities) {
          return _this9.setVisibilities(visibilities);
        },
        setComboboxAccessibility: function setComboboxAccessibility(enabled) {
          return _this9.setComboboxAccessibility(enabled);
        },
        setEnabled: function setEnabled(enabled) {
          return _this9.setEnabled(enabled);
        },
        setContextKey: function setContextKey(contextKey) {
          return _this9.options.setContextKey(contextKey);
        }
      };
      this.updateStyles();
      return this.ui;
    }
  }, {
    key: "pick",
    value: function pick(picks) {
      var _this10 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var token = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : CancellationToken.None;
      return new Promise(function (doResolve, reject) {
        var _resolve = function resolve(result) {
          _resolve = doResolve;

          if (options.onKeyMods) {
            options.onKeyMods(input.keyMods);
          }

          doResolve(result);
        };

        if (token.isCancellationRequested) {
          _resolve(undefined);

          return;
        }

        var input = _this10.createQuickPick();

        var activeItem;
        var disposables = [input, input.onDidAccept(function () {
          if (input.canSelectMany) {
            _resolve(input.selectedItems.slice());

            input.hide();
          } else {
            var result = input.activeItems[0];

            if (result) {
              _resolve(result);

              input.hide();
            }
          }
        }), input.onDidChangeActive(function (items) {
          var focused = items[0];

          if (focused && options.onDidFocus) {
            options.onDidFocus(focused);
          }
        }), input.onDidChangeSelection(function (items) {
          if (!input.canSelectMany) {
            var result = items[0];

            if (result) {
              _resolve(result);

              input.hide();
            }
          }
        }), input.onDidTriggerItemButton(function (event) {
          return options.onDidTriggerItemButton && options.onDidTriggerItemButton(Object.assign(Object.assign({}, event), {
            removeItem: function removeItem() {
              var index = input.items.indexOf(event.item);

              if (index !== -1) {
                var items = input.items.slice();
                items.splice(index, 1);
                input.items = items;
              }
            }
          }));
        }), input.onDidChangeValue(function (value) {
          if (activeItem && !value && (input.activeItems.length !== 1 || input.activeItems[0] !== activeItem)) {
            input.activeItems = [activeItem];
          }
        }), token.onCancellationRequested(function () {
          input.hide();
        }), input.onDidHide(function () {
          dispose(disposables);

          _resolve(undefined);
        })];
        input.canSelectMany = !!options.canPickMany;
        input.placeholder = options.placeHolder;
        input.ignoreFocusOut = !!options.ignoreFocusLost;
        input.matchOnDescription = !!options.matchOnDescription;
        input.matchOnDetail = !!options.matchOnDetail;
        input.matchOnLabel = options.matchOnLabel === undefined || options.matchOnLabel; // default to true

        input.autoFocusOnList = options.autoFocusOnList === undefined || options.autoFocusOnList; // default to true

        input.quickNavigate = options.quickNavigate;
        input.contextKey = options.contextKey;
        input.busy = true;
        Promise.all([picks, options.activeItem]).then(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              items = _ref3[0],
              _activeItem = _ref3[1];

          activeItem = _activeItem;
          input.busy = false;
          input.items = items;

          if (input.canSelectMany) {
            input.selectedItems = items.filter(function (item) {
              return item.type !== 'separator' && item.picked;
            });
          }

          if (activeItem) {
            input.activeItems = [activeItem];
          }
        });
        input.show();
        Promise.resolve(picks).then(undefined, function (err) {
          reject(err);
          input.hide();
        });
      });
    }
  }, {
    key: "createQuickPick",
    value: function createQuickPick() {
      var ui = this.getUI();
      return new QuickPick(ui);
    }
  }, {
    key: "show",
    value: function show(controller) {
      var ui = this.getUI();
      this.onShowEmitter.fire();
      var oldController = this.controller;
      this.controller = controller;

      if (oldController) {
        oldController.didHide();
      }

      this.setEnabled(true);
      ui.leftActionBar.clear();
      ui.title.textContent = '';
      ui.description.textContent = '';
      ui.rightActionBar.clear();
      ui.checkAll.checked = false; // ui.inputBox.value = ''; Avoid triggering an event.

      ui.inputBox.placeholder = '';
      ui.inputBox.password = false;
      ui.inputBox.showDecoration(Severity.Ignore);
      ui.visibleCount.setCount(0);
      ui.count.setCount(0);
      ui.message.textContent = '';
      ui.progressBar.stop();
      ui.list.setElements([]);
      ui.list.matchOnDescription = false;
      ui.list.matchOnDetail = false;
      ui.list.matchOnLabel = true;
      ui.list.sortByLabel = true;
      ui.ignoreFocusOut = false;
      this.setComboboxAccessibility(false);
      ui.inputBox.ariaLabel = '';
      var backKeybindingLabel = this.options.backKeybindingLabel();
      backButton.tooltip = backKeybindingLabel ? localize('quickInput.backWithKeybinding', "Back ({0})", backKeybindingLabel) : localize('quickInput.back', "Back");
      ui.container.style.display = '';
      this.updateLayout();
      ui.inputBox.setFocus();
    }
  }, {
    key: "setVisibilities",
    value: function setVisibilities(visibilities) {
      var ui = this.getUI();
      ui.title.style.display = visibilities.title ? '' : 'none';
      ui.description.style.display = visibilities.description ? '' : 'none';
      ui.checkAll.style.display = visibilities.checkAll ? '' : 'none';
      ui.filterContainer.style.display = visibilities.inputBox ? '' : 'none';
      ui.visibleCountContainer.style.display = visibilities.visibleCount ? '' : 'none';
      ui.countContainer.style.display = visibilities.count ? '' : 'none';
      ui.okContainer.style.display = visibilities.ok ? '' : 'none';
      ui.customButtonContainer.style.display = visibilities.customButton ? '' : 'none';
      ui.message.style.display = visibilities.message ? '' : 'none';
      ui.progressBar.getContainer().style.display = visibilities.progressBar ? '' : 'none';
      ui.list.display(!!visibilities.list);
      ui.container.classList[visibilities.checkAll ? 'add' : 'remove']('show-checkboxes');
      this.updateLayout(); // TODO
    }
  }, {
    key: "setComboboxAccessibility",
    value: function setComboboxAccessibility(enabled) {
      if (enabled !== this.comboboxAccessibility) {
        var ui = this.getUI();
        this.comboboxAccessibility = enabled;

        if (this.comboboxAccessibility) {
          ui.inputBox.setAttribute('role', 'combobox');
          ui.inputBox.setAttribute('aria-haspopup', 'true');
          ui.inputBox.setAttribute('aria-autocomplete', 'list');
          ui.inputBox.setAttribute('aria-activedescendant', ui.list.getActiveDescendant() || '');
        } else {
          ui.inputBox.removeAttribute('role');
          ui.inputBox.removeAttribute('aria-haspopup');
          ui.inputBox.removeAttribute('aria-autocomplete');
          ui.inputBox.removeAttribute('aria-activedescendant');
        }
      }
    }
  }, {
    key: "setEnabled",
    value: function setEnabled(enabled) {
      if (enabled !== this.enabled) {
        this.enabled = enabled;

        var _iterator = _createForOfIteratorHelper(this.getUI().leftActionBar.viewItems),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            item.getAction().enabled = enabled;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        var _iterator2 = _createForOfIteratorHelper(this.getUI().rightActionBar.viewItems),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _item = _step2.value;
            _item.getAction().enabled = enabled;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        this.getUI().checkAll.disabled = !enabled; // this.getUI().inputBox.enabled = enabled; Avoid loosing focus.

        this.getUI().ok.enabled = enabled;
        this.getUI().list.enabled = enabled;
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      var _a;

      var controller = this.controller;

      if (controller) {
        var focusChanged = !((_a = this.ui) === null || _a === void 0 ? void 0 : _a.container.contains(document.activeElement));
        this.controller = null;
        this.onHideEmitter.fire();
        this.getUI().container.style.display = 'none';

        if (!focusChanged) {
          if (this.previousFocusElement && this.previousFocusElement.offsetParent) {
            this.previousFocusElement.focus();
            this.previousFocusElement = undefined;
          } else {
            this.options.returnFocus();
          }
        }

        controller.didHide();
      }
    }
  }, {
    key: "layout",
    value: function layout(dimension, titleBarOffset) {
      this.dimension = dimension;
      this.titleBarOffset = titleBarOffset;
      this.updateLayout();
    }
  }, {
    key: "updateLayout",
    value: function updateLayout() {
      if (this.ui) {
        this.ui.container.style.top = "".concat(this.titleBarOffset, "px");
        var style = this.ui.container.style;
        var width = Math.min(this.dimension.width * 0.62
        /* golden cut */
        , QuickInputController.MAX_WIDTH);
        style.width = width + 'px';
        style.marginLeft = '-' + width / 2 + 'px';
        this.ui.inputBox.layout();
        this.ui.list.layout(this.dimension && this.dimension.height * 0.4);
      }
    }
  }, {
    key: "applyStyles",
    value: function applyStyles(styles) {
      this.styles = styles;
      this.updateStyles();
    }
  }, {
    key: "updateStyles",
    value: function updateStyles() {
      if (this.ui) {
        var _this$styles$widget = this.styles.widget,
            quickInputTitleBackground = _this$styles$widget.quickInputTitleBackground,
            quickInputBackground = _this$styles$widget.quickInputBackground,
            quickInputForeground = _this$styles$widget.quickInputForeground,
            contrastBorder = _this$styles$widget.contrastBorder,
            widgetShadow = _this$styles$widget.widgetShadow;
        this.ui.titleBar.style.backgroundColor = quickInputTitleBackground ? quickInputTitleBackground.toString() : '';
        this.ui.container.style.backgroundColor = quickInputBackground ? quickInputBackground.toString() : '';
        this.ui.container.style.color = quickInputForeground ? quickInputForeground.toString() : '';
        this.ui.container.style.border = contrastBorder ? "1px solid ".concat(contrastBorder) : '';
        this.ui.container.style.boxShadow = widgetShadow ? "0 5px 8px ".concat(widgetShadow) : '';
        this.ui.inputBox.style(this.styles.inputBox);
        this.ui.count.style(this.styles.countBadge);
        this.ui.ok.style(this.styles.button);
        this.ui.customButton.style(this.styles.button);
        this.ui.progressBar.style(this.styles.progressBar);
        this.ui.list.style(this.styles.list);
        var content = [];

        if (this.styles.list.listInactiveFocusForeground) {
          content.push(".monaco-list .monaco-list-row.focused { color:  ".concat(this.styles.list.listInactiveFocusForeground, "; }"));
          content.push(".monaco-list .monaco-list-row.focused:hover { color:  ".concat(this.styles.list.listInactiveFocusForeground, "; }")); // overwrite :hover style in this case!
        }

        if (this.styles.list.pickerGroupBorder) {
          content.push(".quick-input-list .quick-input-list-entry { border-top-color:  ".concat(this.styles.list.pickerGroupBorder, "; }"));
        }

        if (this.styles.list.pickerGroupForeground) {
          content.push(".quick-input-list .quick-input-list-separator { color:  ".concat(this.styles.list.pickerGroupForeground, "; }"));
        }

        var newStyles = content.join('\n');

        if (newStyles !== this.ui.styleSheet.innerHTML) {
          this.ui.styleSheet.innerHTML = newStyles;
        }
      }
    }
  }]);

  return QuickInputController;
}(Disposable);
QuickInputController.MAX_WIDTH = 600; // Max total width of quick input widget